module.exports = function () {
  const section = document.querySelector(".form-hero");
  const formContainer = document.querySelector(".form-hero__content__form-container");
  const imageContainer = document.querySelector(".form-hero__image-container");
  const form = document.querySelector(".form-hero__content__form");

  if (!formContainer || !imageContainer || !form) return;

  const setFormHeight = () => {
    if(form.offsetHeight > section.offsetHeight) {
      formContainer.style.minHeight = `${form.offsetHeight / 2}px`;
      imageContainer.style.minHeight = `${form.offsetHeight / 2}px`;
      section.style.minHeight = `${form.offsetHeight}px`;
    }
  };

  const handleSizeChange = (e) => {
    if (e.matches) {
      setFormHeight();
    } else {
      formContainer.removeAttribute("style");
      imageContainer.removeAttribute("style");
      section.removeAttribute("style");
    }
  }

  if (window) {
    const mq = window.matchMedia("(min-width: 992px)");
    mq.addEventListener("change", handleSizeChange);
    handleSizeChange(mq);
  }



};
